import React from "react";

import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import { DropdownShadow } from "components/deal";
import { ReportsQueries } from "store/types";

import { currenciesArray } from "../../../constants";
import { useGroupByContent } from "../../../hooks";
import { DataFormation } from "../Group-by-content/GroupByContent";

import "./GroupByCurrency.styles.scss";

interface Props {
  onChangeDataFormation?: (dataFormation: DataFormation) => void;
}

export const GroupByCurrency: React.FC = ({ onChangeDataFormation }: Props) => {
  const fields: Array<keyof ReportsQueries> = ["currency", "exchangeMethod"];

  const { setFieldValue, values } = useGroupByContent({ fields, onChangeDataFormation });

  return (
    <div className="group-by-currency">
      <div className="row">
        <span className="query-manager__currency-title" style={{ marginRight: "22px" }}>
          Currency:{" "}
        </span>
        <DropdownShadow
          className="deal-header__status"
          status={values.currency || "USD"}
          statuses={currenciesArray}
          onChange={(value) => setFieldValue("currency", value)}
        />
      </div>

      <FormControl sx={{ flexDirection: "row", alignItems: "center" }}>
        <FormLabel id="demo-controlled-radio-buttons-group" sx={{ marginRight: "25px" }}>
          Hedging:
        </FormLabel>
        <RadioGroup
          sx={{ flexDirection: "row" }}
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={values.exchangeMethod}
          onChange={(e) => {
            setFieldValue("exchangeMethod", e.target.value);
          }}
        >
          <FormControlLabel value="toDate" control={<Radio />} label="To Date" />
          <FormControlLabel value="realDate" control={<Radio />} label="Transaction Date" />
        </RadioGroup>
      </FormControl>
    </div>
  );
};
